<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div class="flex-row">
			<yx-avatar :size="40" :src="row.avatar_url" class="mt-4" />
			<div class="right ml-8 font-h4-regular yx-color-text-regular">
				<div class="yx-color-text-primary">{{ row.nick_name }}</div>
				<div>姓名: {{ row.contact_name }}</div>
				<div>微信号: {{ row.wechat_account }}</div>
				<div>手机号: {{ row.mobile || '-' }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	components: {
		
	},
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
</style>
